'use client'

import { ProductTechnicalSpecs } from '@/feature/product/components/product-technical-specs/ProductTechnicalSpecs.client'
import {
  PRODUCT_SEE_MORE_LABEL_KEY,
  TECHNICAL_SPECS_ANCHOR_ID,
} from '@/feature/product/services/product.constants'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { ReadMoreLink } from '@/ui/read-more-link/ReadMoreLink.client'
import { Title } from '@/ui/text/title/Title'
import { gql } from '@gql-generated/gql'
import type { ProductTechnicalSpecsSection_ProductFragment } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  fragment ProductTechnicalSpecsSection_Product on Product {
    mainTechnicalSpecs {
      ...ProductTechnicalSpecs_TechnicalSpecs
    }
    technicalSpecs {
      ...ProductTechnicalSpecs_TechnicalSpecs
    }
    norms {
      ...ProductTechnicalSpecsFull_Norms
    }
  }
`)

type ProductTechnicalSpecsSectionProps = {
  product: ProductTechnicalSpecsSection_ProductFragment
}

export function ProductTechnicalSpecsSection({ product }: ProductTechnicalSpecsSectionProps) {
  const { t } = useTranslation(['productPage'])
  const { mainTechnicalSpecs, technicalSpecs, norms } = product

  if (!mainTechnicalSpecs?.length) return null

  const showReadMoreLink =
    (technicalSpecs?.length ?? 0) > mainTechnicalSpecs.length || !!norms?.length

  return (
    <>
      <Title size="2xl" as="h2" className="font-bold">
        {t('productPage:technicalSpecs.title')}
      </Title>
      <ProductTechnicalSpecs technicalSpecs={mainTechnicalSpecs} />
      {showReadMoreLink && (
        <ReadMoreLink
          type="navigate"
          targetId={`#${TECHNICAL_SPECS_ANCHOR_ID}`}
          expandLabelKey={PRODUCT_SEE_MORE_LABEL_KEY}
        />
      )}
    </>
  )
}
